import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Chat({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Chat</title>
      <path
        d="M9.40334 11.6095C9.40334 12.1474 8.93821 12.5835 8.36443 12.5835C7.79066 12.5835 7.32553 12.1474 7.32553 11.6095C7.32553 11.0716 7.79066 10.6355 8.36443 10.6355C8.93821 10.6355 9.40334 11.0716 9.40334 11.6095Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M12.0004 12.5835C12.5741 12.5835 13.0393 12.1474 13.0393 11.6095C13.0393 11.0716 12.5741 10.6355 12.0004 10.6355C11.4266 10.6355 10.9614 11.0716 10.9614 11.6095C10.9614 12.1474 11.4266 12.5835 12.0004 12.5835Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M16.6752 11.6095C16.6752 12.1474 16.21 12.5835 15.6363 12.5835C15.0625 12.5835 14.5974 12.1474 14.5974 11.6095C14.5974 11.0716 15.0625 10.6355 15.6363 10.6355C16.21 10.6355 16.6752 11.0716 16.6752 11.6095Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00098 10.9735C3.00098 6.48022 7.02674 2.83105 12.0005 2.83105C16.9743 2.83105 21 6.48022 21 10.9735C21 15.4668 16.9743 19.1159 12.0005 19.1159C10.981 19.135 9.966 18.9768 9.00066 18.6484C8.13609 19.4735 7.19707 20.2169 6.19562 20.8691C5.90001 21.0714 5.54845 21.176 5.19033 21.1682C4.83221 21.1605 4.48551 21.0407 4.19895 20.8258C3.91239 20.6109 3.70035 20.3116 3.59262 19.97C3.4849 19.6283 3.4869 19.2616 3.59835 18.9211C4.16126 17.4793 4.24325 15.8941 3.8321 14.4019C3.31369 13.3314 3.03031 12.1625 3.00098 10.9735ZM19.3767 10.9475C19.3767 7.37627 16.0652 4.45435 12.0005 4.45435C7.93578 4.45435 4.63725 7.41523 4.63725 11.0124C4.67182 11.9878 4.91539 12.9444 5.3515 13.8175C5.91117 15.6441 5.84259 17.6056 5.15671 19.3886V19.4666C5.18644 19.4749 5.21788 19.4749 5.24761 19.4666C6.17327 18.8767 7.04269 18.2029 7.84488 17.4537L8.57211 16.7264L9.54609 17.0641C10.3369 17.3281 11.1669 17.4555 12.0005 17.4407C16.0652 17.4407 19.3767 14.5188 19.3767 10.9475Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
